import { render, staticRenderFns } from "./PdfFileIcon.vue?vue&type=template&id=0aa49a9c"
import script from "./PdfFileIcon.vue?vue&type=script&lang=ts"
export * from "./PdfFileIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa49a9c')) {
      api.createRecord('0aa49a9c', component.options)
    } else {
      api.reload('0aa49a9c', component.options)
    }
    module.hot.accept("./PdfFileIcon.vue?vue&type=template&id=0aa49a9c", function () {
      api.rerender('0aa49a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/PdfFileIcon.vue"
export default component.exports